import React, { FC, ReactNode } from "react";

interface FeatureHighlightProps {
  icon: ReactNode;
  title: string;
  description: string;
}

export const FeatureHighlight: FC<FeatureHighlightProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0 flex flex-col justify-center items-center w-12 h-12 bg-violet-50 rounded-full">
        <div className="w-6 h-6 flex items-center justify-center">{icon}</div>
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-base font-extrabold text-indigo-950">{title}</div>
        <div className="text-base text-gray-500">{description}</div>
      </div>
    </div>
  );
};
